var map = {
	"./recommendations/recommendations-proxy.module.ngfactory": [
		"8Y1L",
		1,
		0
	],
	"./search/search-proxy.module.ngfactory": [
		"/43d",
		4
	],
	"./vdp/vdp-proxy.module.ngfactory": [
		"AfKH",
		0,
		2
	],
	"./watchlist/watchlist-proxy.module.ngfactory": [
		"NoSS",
		0,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "lQVv";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/main/angular/$$_gendir lazy
// module id = lQVv
// module chunks = 6